// extracted by mini-css-extract-plugin
export default {"colors-container":"Colors_colors-container__q-+7a","colors-icon":"Colors_colors-icon__W81V3"};